import { compose, prop, propOr } from 'ramda';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getCampaignStates = (campaignId) => compose(propOr(EMPTY_VALUES.ARRAY, campaignId), getRoot);

export const getSelectedFeedbackStateId = compose(prop('selectedFeedbackStateId'), getRoot);
